export default "__VITE_ASSET__BUBSp9OF__"